export interface IRevisionPartVOs {
    createDate: string,
    createUser: string,
    id: string,
    isPart: boolean,
    longDescription: string,
    part: string,
    price: number,
    quantity: string,
    shortDescription: string,
  }
